import React, { Component } from 'react';
import { NavMenuDetails } from 'components/shared/Layout/NavMenu/NavMenuDetails';
import NavMenu from './NavMenu';
export default class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <div className="wrapper-content">{this.props.children}</div>
      </div>
    );
  }
}
